import { Grid } from '@mui/material';
import { languageShort, LocationMapper } from '@nx-smartmonkey/shared/domain';
import { OSMap, OSMarker, RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import { useParams } from 'react-router-dom';

import { getDistance } from '@nx-smartmonkey/shared/helpers';
import NoLocationImg from '../../../../../../../assets/img/no_location_placeholder.jpg';
import { DistanceType } from '../../../../../../../domain/driversProject/DriversProject';
import { Route } from '../../../../../../../domain/route/Route';
import { kmToSM } from '../../../../../../../helpers/Units';
import Button from '../../../../../../../react-components/Button';
import { Text } from '../../../../../../../react-components/Text';
import { useCurrentPosition } from '../../../../../hooks/position/useCurrentPosition';
import { useRetrieveVehicle } from '../../../../../hooks/useRetrieveVehicle';
import { useLocationContext } from '../../../../../locationContext/context';
interface ReportMapProps {
  selectedRoute: Route;
  showMandatory?: boolean;
  hasValue?: boolean;
}

export const ReportMap = ({ selectedRoute, showMandatory, hasValue }: ReportMapProps) => {
  const { stopId } = useParams();
  const { data: vehicleData } = useRetrieveVehicle();
  const { locationState } = useLocationContext();
  useCurrentPosition();
  const stop = stopId ? selectedRoute.getStopById(stopId) : undefined;

  // if (!stop) return null;

  if (!locationState?.currentPosition) {
    return (
      <>
        <div style={{ position: `relative`, border: `1px solid ${RoutalPalette.primary40}`, borderRadius: `10px` }}>
          <div
            style={{
              zIndex: -1,
              width: `100%`,
              height: `160px`,
              borderRadius: `10px`,
              position: `absolute`,
              top: 0,
              left: 0,
              backgroundImage: `url(${NoLocationImg})`,
              backgroundSize: `cover`,
              filter: `brightness(0.5)`,
            }}
          />
          <Grid
            style={{ height: `160px`, padding: `0 24px` }}
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
          >
            <Grid item>
              <Button
                style={{ padding: `4px 16px` }}
                intlId="driver.stop.report.share_location_now"
                onClick={() =>
                  //TODO - Implement this que recarge el usePoisition
                  navigator.geolocation.getCurrentPosition(
                    () => {
                      //Success - Ha salido el popUp y ha aceptado.
                    },
                    () => {
                      //Si error que le mande a la web de compartir ubicación
                      window.open(getGeolocationHelpLink(), `_blank`);
                    }
                  )
                }
              />
            </Grid>
          </Grid>
        </div>
        {showMandatory && !hasValue && (
          <>
            <VSpacer small />
            <Grid style={{ display: `flex` }}>
              <Text
                variant="label"
                intlId="drivers.report.map.mandatory_field"
                style={{ color: RoutalPalette.error.medium }}
              />
            </Grid>
          </>
        )}
      </>
    );
  }
  let final_num = ``;
  if (stop) {
    const distanceToStop =
      getDistance(
        { lat: locationState.currentPosition.lat as number, lng: locationState.currentPosition.lng as number },
        { lat: stop.location?.lat as number, lng: stop.location?.lng as number }
      ) / 1000; //Lo pasamos a km para kmToSM

    const finalTotalDistance = distanceToStop
      ? kmToSM(distanceToStop, vehicleData?.project.units.distance as DistanceType)
      : 0;
    final_num = finalTotalDistance > 100 ? Math.floor(finalTotalDistance).toFixed(0) : finalTotalDistance.toFixed(1);
  }

  return (
    <>
      <div style={{ border: `1px solid ${RoutalPalette.primary40}`, borderRadius: `10px` }}>
        <OSMap
          height="160px"
          zoomControl={false}
          scrollWheelZoom={false}
          dragging={false}
          touchZoom
          mapStyles={{ borderRadius: `10px`, zIndex: 0 }}
        >
          {stop?.location?.isValid() ? (
            <OSMarker
              id={`driver-${stop.id}`}
              key={`driver-${stop.id}`}
              lat={stop.location!.lat as number}
              lng={stop.location!.lng as number}
              number={(stop.order ?? 0) + 1}
              color={RoutalPalette.routeBaseColor}
            />
          ) : null}

          {LocationMapper.toDomain({
            lat: locationState.currentPosition?.lat,
            lng: locationState.currentPosition?.lng,
          }).isValid() ? (
            <OSMarker
              id={`current-position-${selectedRoute!.id}`}
              key={`current-position-${selectedRoute!.id}`}
              lat={locationState.currentPosition.lat as number}
              lng={locationState.currentPosition.lng as number}
              kind={`routal_truck`}
              color={RoutalPalette.routeBaseColor}
            />
          ) : null}
        </OSMap>
      </div>
      {stop?.location?.isValid() && (
        <>
          <VSpacer small />
          <Grid style={{ display: `flex` }}>
            <Text
              variant="label"
              intlId="drivers.report.map.distance_to_stop"
              intlValues={{ distance: `${final_num} ${vehicleData?.project.units.distance as DistanceType}` }}
            />
          </Grid>
        </>
      )}
    </>
  );
};

const getGeolocationHelpLink = () => {
  let { language } = navigator;

  switch (languageShort(language)) {
    case `eu`:
    case `es`:
    case `gl`:
    case `ca`:
      language = `es`;
      break;
    default:
      language = `en`;
      break;
  }
  return `https://support.google.com/chrome/answer/142065?hl=${language}&co=GENIE.Platform%3DAndroid`;
};
